export default Object.freeze({
    ACCESS_TOKEN_NAME: 'access_token',
    REFRESH_TOKEN_NAME: 'refresh_token'
});